import React, { ChangeEventHandler, FormEventHandler } from 'react';

import FormInvalid from './FormInvalid';

type Props = {
    type: string;
    field: string;
    value: string | number;
    label: string | JSX.Element;
    error: string;
    handleChange: ChangeEventHandler<HTMLInputElement>;
    onBlur?: FormEventHandler<HTMLInputElement>;
    disableAutofill?: boolean;
    required?: boolean;
    disabled?: boolean;
    min?: string | number;
    max?: string | number;
    step?: string | number;
    placeholder?: string;
};

function FormGroup({
    type,
    field,
    value,
    label,
    error,
    handleChange,
    onBlur = () => {},
    disableAutofill = false,
    required = false,
    disabled = false,
    min,
    max,
    step,
    placeholder,
}: Props) {
    const hasError = (error ?? false) !== false;

    return (
        <div className="form-group">
            <label htmlFor={field}>
                {label} {required ?? <span className="text-danger text-sm">*</span>}
            </label>
            <input
                type={type}
                id={field}
                className={`form-control ${hasError ? 'is-invalid' : ''}`}
                name={field}
                value={value}
                onChange={handleChange}
                onBlur={onBlur}
                autoComplete={disableAutofill === true ? 'do-not-autofill' : undefined}
                required={required}
                disabled={disabled}
                min={min}
                max={max}
                step={step}
                placeholder={placeholder}
            />
            {hasError && <FormInvalid message={error} />}
        </div>
    );
}

export default FormGroup;
